export enum DASHBOARD_ACCESS {
  UNSET = -1,
  NON_RIGHTSHOLDER = 1,
  VIDEO_RIGHTSHOLDER = 2,
  VIDEO_PUBLISHER = 3,
  CAMPAIGN_ORGANISATION = 4,
  DEMO = 5,
}